



























import { defineComponent, reactive, watch } from '@vue/composition-api';

const CommonTimePicker = defineComponent({
  props: {
    label: { default: 'เวลา' },
    value: { default: () => '00:00:00' },
    millisecond: { default: () => true },
    level: { default: undefined },
  },
  setup(props, { emit }) {
    const HOURS = [
      '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
      '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
      '20', '21', '22', '23',
    ];
    const MINUTES = [
      '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
      '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
      '20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
      '30', '31', '32', '33', '34', '35', '36', '37', '38', '39',
      '40', '41', '42', '43', '44', '45', '46', '47', '48', '49',
      '50', '51', '52', '53', '54', '55', '56', '57', '58', '59',
    ];
    const time = reactive({
      hour: props.value.substring(0, 2),
      minute: props.value.substring(3, 5),
    });
    const setTime = (hour: any, minute: any) => {
      if (hour !== -1) time.hour = hour;
      else time.minute = minute;
      if (props.millisecond) emit('input', `${time.hour}:${time.minute}:00`);
      else emit('input', `${time.hour}:${time.minute}`);
    };

    watch(() => props.value, (newVal: string, oldVal: string) => {
      if (newVal !== oldVal) {
        // if (!(newVal === '00:00:00' || newVal === '00:00')) {
        //   console.log(newVal);
        time.hour = newVal.substring(0, 2);
        time.minute = newVal.substring(3, 5);
        // }
      }
    });

    return {
      HOURS,
      MINUTES,
      time,
      setTime,
    };
  },
});

export default CommonTimePicker;
